import { useCallback, useEffect, useRef } from "react";
import { createHedgeSocket, type HedgeSocket } from "@/lib/ws";
import { useDashboardStore } from "@/store/dashboard.store";

export function useHedgeSocket(pairId: string | null): { send: (msg: unknown) => boolean } {
  const ingest = useDashboardStore((s) => s.ingest);
  const setConnectionStatus = useDashboardStore((s) => s.setConnectionStatus);
  const socketRef = useRef<HedgeSocket | null>(null);

  useEffect(() => {
    if (!pairId) {
      socketRef.current = null;
      return;
    }
    setConnectionStatus(pairId, "connecting");
    const socket = createHedgeSocket(pairId, (event) => {
      ingest(pairId, event);
    }, {
      onOpen: () => {
        console.info(`[hedge-ws] open pair=${pairId}`);
        setConnectionStatus(pairId, "open");
      },
      onClose: () => {
        console.warn(`[hedge-ws] close pair=${pairId} — reconnecting…`);
        setConnectionStatus(pairId, "closed");
      },
    });
    socketRef.current = socket;
    return () => {
      socket.close();
      socketRef.current = null;
      setConnectionStatus(pairId, "closed");
    };
  }, [pairId, ingest, setConnectionStatus]);

  const send = useCallback((msg: unknown): boolean => {
    return socketRef.current?.send(msg) ?? false;
  }, []);

  return { send };
}
